export var ClaimConstants;
(function (ClaimConstants) {
    ClaimConstants["OwnedFranchiseIdClaimType"] = "FranForce.OwnedFranchiseId";
    ClaimConstants["EmployedFranchiseIdClaimType"] = "FranForce.EmployedFranchiseId";
    ClaimConstants["ManagedConceptIdClaimType"] = "FranForce.ManagedConceptId";
    ClaimConstants["IsDppEmployeePermissionClaimType"] = "FranForce.IsDppEmployee";
    ClaimConstants["CanViewFranchisePosClaimType"] = "FranForce.CanViewFranchisePos";
    ClaimConstants["DppEmployeePermissionClaimType"] = "FranForce.IsDppEmployee";
    ClaimConstants["SyncControllerPermissionClaimType"] = "FranForce.Sync.ControllerPermission";
    ClaimConstants["ManagedCallCenterIdClaimType"] = "FranForce.C4.ManagedCallCenterId";
    ClaimConstants["ManagedCallCenterConceptIdClaimType"] = "FranForce.C4.ManagedCallCenterConceptId";
    ClaimConstants["AssignedPosEmployeeIdClaimType"] = "FranForce.AssignedPosEmployeeId";
    ClaimConstants["ManagedCallCenterQueueVisibilityIdClaimType"] = "FranForce.C4.ManagedQueueVisibilityId";
})(ClaimConstants || (ClaimConstants = {}));
